import api from "./api";

export const getUsers = async () => {
  return await api.get("/user/users");
};

export const updateUser = async (data) => {
  return await api.put("/user/users",data);
};

export const addUser = async (data) => {
  return await api.post("/user/users",data);
};

export const deleteUser = async (id) => {
  return await api.delete(`/user/users/${id}`);
};

export const sendEmail = async (templateId, userEmail, provider = "local") => {
  return await api.post("/user/users/send-mail", {
    templateId,
    userEmail,
    provider,
  });
};

export const getGoogleSheetStatus = async () => {
  return await api.get("/auth/google/status");
};

export const refreshGoogleSheetToken = async () => {
  return await api.post("/auth/google/refresh-token");
};
